
(function($){$.fn.extend({device_confirm:function(){var userAgentInfo = navigator.userAgent;var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];var flag = true;for (var v = 0; v < Agents.length; v++) {if (userAgentInfo.indexOf(Agents[v]) > 0) {flag = false;break;}}return flag;}})})(jQuery);(function($){$.fn.extend({system_confirm:function(){var userAgentInfo = navigator.userAgent;if(userAgentInfo.indexOf("Win")>-1){return "win"}else if(userAgentInfo.indexOf("Mac")>-1){return "mac"}}})})(jQuery);if(window.innerWidth>956){$(".tab_index").mouseenter(function(){$("#submenu_container").addClass("active"); $(".submenu").eq($(this).index(".tab_index")).addClass("active").siblings(".submenu").removeClass("active");});$("#submenu_container").mouseleave(function(){$("#submenu_container").removeClass("active");$(".submenu").removeClass("active");});};function system_confirm(){var userAgentInfo = navigator.userAgent;if(userAgentInfo.indexOf("Win")>-1){return "win"}else if(userAgentInfo.indexOf("Mac")>-1){return "mac"}};function device_confirm(){var userAgentInfo = navigator.userAgent;var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];var flag = true;for (var v = 0; v < Agents.length; v++) {if (userAgentInfo.indexOf(Agents[v]) > 0) {flag = false;break;}}return flag;};
//自定义方法
jQuery.fn.extend({
    fadeins:function(start,time,interval){
      var start;
      var that=$(this);
      setInterval(function(){
        that.eq(start).fadeIn(time);
        start++;
        if(start>=that.length){
          return false;
        }
      },interval)
    },
    opacitys:function(start,time,interval){
        var start;
        var that=$(this);
        setInterval(function(){
          that.eq(start).animate({
              opacity:1
          },time)
          start++;
          if(start>=that.length){
            return false;
          }
        },interval)
      },
    roll:function(action,value){
      if(value=="undefined"){value=0;}
      var that=$(this);
      $(window).scroll(function(){
          try{
            if($(document).scrollTop()>=that.offset().top-value){
              action();
            }
          }
          catch(e){
              
          }
      });
    },
    rotation_chart:function(content,left,right,name,times){
        times= times || 4000;
        var i=0;
        var that=$(this);
        var time;
        function run(){
            clearInterval(time);
            time=setInterval(function(){
                i++;
                if(i>=that.length){
                    i=0;
                }
                that.eq(i).addClass(name).siblings().removeClass(name);
                content.children().eq(i).fadeIn("slow").siblings().fadeOut("slow");
                content.height(content.children().eq(i).height());
            },times)
        }
        run();
        try{
            left.click(function(){
                i--;
                if(i<0){
                    i=that.length-1;
                }
                that.eq(i).addClass(name).siblings().removeClass(name);
                content.children().eq(i).fadeIn("slow").siblings().fadeOut("slow");
                content.height(content.children().eq(i).height());
                clearInterval(time);
                run();
            });
        }
        catch(e){

        };
        try{
            right.click(function(){
                i++;
                if(i>=that.length){
                    i=0;
                }
                that.eq(i).addClass(name).siblings().removeClass(name);
                content.children().eq(i).fadeIn("slow").siblings().fadeOut("slow");
                content.height(content.children().eq(i).height());
                clearInterval(time);
                run();
            });
        }
        catch(e){

        }
        $(this).mouseover(function(){
            $(this).addClass(name).siblings().removeClass(name);
            content.children().eq($(this).index()).fadeIn("slow").siblings().fadeOut("slow");
            content.height(content.children().eq($(this).index()).height());
            i=$(this).index();
            clearInterval(time);
            run();
        })
    },
    tabs:function(tab,content,name){
        for(var i=0;i<tab.children().length;i++){
            (function(i){
                $(tab).children().eq(i).mouseover(function(){
                    $(this).addClass(name).siblings().removeClass(name);
                    content.children().eq(i).addClass(name).siblings().removeClass(name);
                })
            })(i)

        }
    }
});
function c_tabs(tab,content,name){
    for(var i=0;i<tab.children().length;i++){
        (function(i){
            $(tab).children().eq(i).click(function(){
                $(this).addClass(name).siblings().removeClass(name);
                content.children().eq(i).addClass(name).siblings().removeClass(name);
            })
        })(i)
    }
};
(function () {
    var isMac,device_com;
    if(system_confirm()=="mac"){isMac=true}
    else if(system_confirm()=="win"){isMac=false}
    if(device_confirm()==true){device_com=true}
    else if(device_confirm()==false){device_com=false}
    if (isMac) {
        $('.mac_btn_box').css({"display":"flex"});
        $('.mac_btn').css({"display":"block"});
        $('.mac_btn_inline').css({"display":"inline-block"});
        $('.win_btn_box').css({"display":"none"});
        $('.win_btn').css({"display":"none"});
        $('.win_btn_inline').css({"display":"none"});
        $('.mobile_btn').css({"display":"none"});
        $('.banner .free_sup_ver_mac').css({"display":"block"});
        $('.banner .free_sup_ver_win').css({"display":"none"});
    } else if (!isMac && device_com == true) {
        $('.win_btn_box').css({"display":"flex"});
        $('.win_btn').css({"display":"block"});
        $('.mac_btn_box').css({"display":"none"});
        $('.mac_btn_inline').css({"display":"none"});
        $('.mac_btn').css({"display":"none"});
        $('.mobile_btn').css({"display":"none"});
        $('.win_btn_inline').css({"display":"inline-block"});
        $('.banner .free_sup_ver_mac').css({"display":"none"});
        $('.banner .free_sup_ver_win').css({"display":"block"});
      
    } else if (device_com == false) {
        $('.pc_btn').css({"display":"none"});
        $('.mobile_btn').show();
        $('.win_btn_inline').css({"display":"inline-block"});
        $('.mac_btn_inline').css({"display":"none"});
    };
})();
//点击取消下拉
(function(){
    var i=0;
    //移动端下拉效果
    $('.toggle_nav').click(function(){
        if($('.nav').css('display')=='none'){
            $('.nav').show();
            $('.nav_bg').show();
        }else{
            $('.nav').hide();
            $('.nav_bg').hide();
        }
        $('.iphone-eraser-nav>.center>ul').hide();
        $('.iphone-eraser-nav>.center>span>i').removeClass('active');
    });
    $('body').append('<div class="nav_bg"></div>')
    $('.nav_bg').click(function(){
        i=0;
        $(this).hide();
        $('.iphone-eraser-nav>.center>span>i').removeClass('active');
        $('.iphone-eraser-nav>.center>ul').hide();
        if($(window).width()<=1200){
            $('.nav').hide();
        }
    });
})();

(function(){
    function getMaxHeight(){
        var Maxheight = [];
        for(var i = 0;i < $('.product_main>ul>li>div').length;i++){
            Maxheight.push($('.product_main>ul>li>div').eq(i).height());
        }
        $('.product_main').height(Maxheight.sort()[Maxheight.length - 1] + 'px');
        $('.product_main ul').height(Maxheight.sort()[Maxheight.length - 1] + 'px');
        $('.product_main>ul>li>div').css({"height":'100%'})
    }
    //下拉
    $('.product').mouseover(getMaxHeight);
    // 划入动画
    $('.product_main>ul>li>div').on('click',function(e){
        e=e||window.event,window.event?e.stopPropagation():window.cancelBubble=!0;
    });
    $('.product_main>ul>li>span').on('click',function(e){
        e=e||window.event,window.event?e.stopPropagation():window.cancelBubble=!0;
        $(this).parent().addClass("active").siblings().removeClass("active");
    });

    $('.product,.head_down').hover(function(){
        $(this).children('img').attr('src','https://www.apeaksoft.com/images/drop-arrow-s.png');
        $(this).siblings('li').children('img').attr('src','https://www.apeaksoft.com/images/drop-arrow.png');
    });

    $('.product_down>ul>li').click(function(){
        $(this).addClass("active").siblings().removeClass("active");
    });
    $(".product_down>ul>li>div div img").before('<i></i>');
    $(".product_down>ul>li>div div.h_down_n i").remove();
    // 导航条划入处理
    $('.header li.head_down').hover(function(){
        $(this).addClass('active').siblings('li').removeClass('active')
    });
    if($(window).width()>1200){
        $('.header li.product').hover(function(){
            $(this).addClass('active').siblings('li').removeClass('active')
        });
    }else{
        $('.header li.product').on('click',function(){
            $(this).addClass('active').siblings('li').removeClass('active')
        });
    }
    $('.header').mouseleave(function(){
        $('.header li.head_down').removeClass('active');
        if($(window).width()>1200){
            $('.header li.product').removeClass('active');
        }
        $('.product>img,.head_down>img').attr('src','https://www.apeaksoft.com/images/drop-arrow.png');
    })
})();
//footer
for(var i=1;i<$('.footer ul').length;i++){
    $('.footer ul').eq(i).find('li').eq(0).click(function(){
        $(this).parent().toggleClass('active');
    })
};

function setCookie(name,value,iDay){      //name相当于键，value相当于值，iDay为要设置的过期时间（天）
    var oDate = new Date();
    oDate.setDate(oDate.getDate() + iDay);
    if(location.hostname.indexOf('.apeaksoft.com')>-1){
        document.cookie = name + '=' + value + ';path=/;domain='+domain+';expires=' + oDate;
    }else{
        document.cookie = name + '=' + value + ';path=/;expires=' + oDate;
    }
}
//获取cookie
function getCookie(name) {
    var prefix = name + "="
    var start = document.cookie.indexOf(prefix)
 
    if (start == -1) {
        return null;
    }
 
    var end = document.cookie.indexOf(";", start + prefix.length)
    if (end == -1) {
        end = document.cookie.length;
    }
 
    var value = document.cookie.substring(start + prefix.length, end)
    return unescape(value);
}

//cookie
(function(){
    var cookie={
        setcookie:function(name,value,Days,path){
            if(typeof(Days)=='undefined'){
                var Days=24;
            }
            if(typeof(path)=='undefined'){
                path='path=/;';
            }else{
                path='';
            }
            var date=new Date(); 
            date.setTime(date.getTime() + Days*1*60*60*1000);
            document.cookie=name+"="+value+";"+path+"expires="+date.toGMTString();
        },
        getcookie:function(name){
            var cookies=document.cookie.split(';'); 
            var cookieValue=0;
            for (var i=0; i < cookies.length; i++){
                var cookie=jQuery.trim(cookies[i]); 
                if(cookie.substring(0, name.length + 1)==(name + '=')){
                    cookieValue=decodeURIComponent(cookie.substring(name.length + 1)); 
                    break; 
                }
            }
            return cookieValue; 
        }
    }
    if(cookie.getcookie('usernotice_pop')==0){
        $('body').append('<div class="usernotice_pop">Apeaksoft uses cookies to ensure you get the best experience on our website.  <a href="https://www.apeaksoft.com/privacy-policy/">Privacy Policy</a> <span class="button">Got it!</span></div>');
       $('.usernotice_pop .button').click(function(){
           $(this).parent().slideUp(400);
           cookie.setcookie('usernotice_pop','in');
       })
    }
})();
//gotop
(function(){
    $('body').append('<img class="gotop" src="https://www.apeaksoft.com/images/top.png" alt="top">');
    $(window).scroll(function(){
        if($(document).scrollTop()>=400){
            $('.gotop').show();
            $('.gotop').click(function(){
                $("body,html").scrollTop(0);
            })
        }else{$('.gotop').hide();};
    });
})();
//aside ads  
(function(){
    if($("html").html().indexOf("side_toggle")>0){
        if(window.location.href.indexOf('/ja/')>-1){
            $("#side_toggle").append('<i></i><a href="/ja/special/promotion.html"><img src="/images/promotion/aside.jpg" alt="Aside" /></a>')
        }else if(window.location.href.indexOf('/fr/')>-1){
            $("#side_toggle").append('<i></i><a href="/fr/special/promotion.html"><img src="/images/promotion/aside.jpg" alt="Aside" /></a>')
        }else if(window.location.href.indexOf('/de/')>-1){
            $("#side_toggle").append('<i></i><a href="/de/special/promotion.html"><img src="/images/promotion/aside.jpg" alt="Aside" /></a>')
        }else if(window.location.href.indexOf('/zh-CN/')>-1){
            $("#side_toggle").append('<i></i><a href="/zh-CN/special/promotion.html"><img src="/images/promotion/aside.jpg" alt="Aside" /></a>')
        }else if(window.location.href.indexOf('/zh-TW/')>-1){
            $("#side_toggle").append('<i></i><a href="/zh-TW/special/promotion.html"><img src="/images/promotion/aside.jpg" alt="Aside" /></a>')
        }else if(window.location.href.indexOf('/cs/')>-1){
            $("#side_toggle").append('<i></i><a href="/cs/special/promotion.html"><img src="/images/promotion/aside.jpg" alt="Aside" /></a>')
        }else if(window.location.href.indexOf('/da/')>-1){
            $("#side_toggle").append('<i></i><a href="/da/special/promotion.html"><img src="/images/promotion/aside.jpg" alt="Aside" /></a>')
        }else if(window.location.href.indexOf('/fi/')>-1){
            $("#side_toggle").append('<i></i><a href="/fi/special/promotion.html"><img src="/images/promotion/aside.jpg" alt="Aside" /></a>')
        }else if(window.location.href.indexOf('/el/')>-1){
            $("#side_toggle").append('<i></i><a href="/el/special/promotion.html"><img src="/images/promotion/aside.jpg" alt="Aside" /></a>')
        }else if(window.location.href.indexOf('/it/')>-1){
            $("#side_toggle").append('<i></i><a href="/it/special/promotion.html"><img src="/images/promotion/aside.jpg" alt="Aside" /></a>')
        }else if(window.location.href.indexOf('/no/')>-1){
            $("#side_toggle").append('<i></i><a href="/no/special/promotion.html"><img src="/images/promotion/aside.jpg" alt="Aside" /></a>')
        }else if(window.location.href.indexOf('/pl/')>-1){
            $("#side_toggle").append('<i></i><a href="/pl/special/promotion.html"><img src="/images/promotion/aside.jpg" alt="Aside" /></a>')
        }else if(window.location.href.indexOf('/pt/')>-1){
            $("#side_toggle").append('<i></i><a href="/pt/special/promotion.html"><img src="/images/promotion/aside.jpg" alt="Aside" /></a>')
        }else if(window.location.href.indexOf('/ru/')>-1){
            $("#side_toggle").append('<i></i><a href="/ru/special/promotion.html"><img src="/images/promotion/aside.jpg" alt="Aside" /></a>')
        }else if(window.location.href.indexOf('/es/')>-1){
            $("#side_toggle").append('<i></i><a href="/es/special/promotion.html"><img src="/images/promotion/aside.jpg" alt="Aside" /></a>')
        }else if(window.location.href.indexOf('/sv/')>-1){
            $("#side_toggle").append('<i></i><a href="/sv/special/promotion.html"><img src="/images/promotion/aside.jpg" alt="Aside" /></a>')
        }else if(window.location.href.indexOf('/hu/')>-1){
            $("#side_toggle").append('<i></i><a href="/hu/special/promotion.html"><img src="/images/promotion/aside.jpg" alt="Aside" /></a>')
        }else if(window.location.href.indexOf('/tr/')>-1){
            $("#side_toggle").append('<i></i><a href="/tr/special/promotion.html"><img src="/images/promotion/aside.jpg" alt="Aside" /></a>')
        }
        else{
            $("#side_toggle").append('<i></i><a href="/special/promotion.html"><img src="/images/promotion/aside.jpg" alt="Aside" /></a>')
        }
    };
    var timer;
    clearTimeout(timer);
    if($(window).width()>1500){
        timer=setTimeout(function(){
        try{$("#side_toggle").addClass("show").removeClass("fade");}catch(e){};
        },1000);
    };
    $("#side_toggle i").click(function(){
        $("#side_toggle").removeClass("show").addClass("fade");
    });
    $("#side_toggle").hover(function(){$(this).addClass("show").removeClass("fade");},function(){});
})();